import axios from 'axios';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getAxiosCancelTokenSource } from '@/app.utils';

const champsEmailState = () => {
    return {
        baseURL: process.env.VUE_APP_BASE_URL,
        emailSenderList: null,
        emailRecipients: null,
        emailContent: null,
        allEmailInformation: null,
        previewEmailContent: null,
        timeZonesForEmail: null,
    };
};

const champsEmailMutations = {
    [storeMutation.setEmailRecipient]: (state, data) => {
        state.emailRecipients = data || null;
    },
    [storeMutation.setEmailSenderList]: (state, data) => {
        state.emailSenderList = data || null;
        if (state.emailSenderList) {
            state.emailSenderList.senderList.forEach((x) => {
                x.fullName = `${x.firstName} ${x.lastName}`;
            });
            state.emailSenderList.loggedInUser.fullName = `${state.emailSenderList.loggedInUser.firstName} ${state.emailSenderList.loggedInUser.lastName}`;
        }
    },
    [storeMutation.setEmailContent]: (state, data) => {
        if (data && data.emailSenderDetails) {
            data.emailSenderDetails.chooseInsert = false;
            if (data.emailSenderDetails.signatureContent) {
                data.emailSenderDetails.chooseInsert = true;
            }
        }
        const files = [];
        if (data && data.emailSenderDetails.attachments && data.emailSenderDetails.attachments.length > 0) {
            data.emailSenderDetails.attachments.forEach((file) => {
                if (typeof file === 'string') {
                    files.push({
                        name: file.substr(file.lastIndexOf('/') + 1, file.length),
                        url: file,
                    });
                }
            });
        }
        data.attachments = files;
        state.emailContent = data || null;
    },
    [storeMutation.setAllEmailInformation]: (state, data) => {
        data.forEach((d) => {
            d.isSelected = false;
        });
        state.allEmailInformation = data || null;
    },
    [storeMutation.setPreviewEmailContent]: (state, data) => {
        state.previewEmailContent = data;
    },
    [storeMutation.setTimeZonesForEmail]: (state, data) => {
        state.timeZonesForEmail = data || null;
    },
};

const champsEmailStateActions = {
    [storeAction.getEmailSenderList]: wrapAction(storeAction.getEmailSenderList, ({ state, commit }, communityId) => {
        //resetting the state to null before making a new call
        commit(storeMutation.setEmailSenderList);

        return axios({
            url: `${state.baseURL}profiles/api/champs/get/email-sender-list/${communityId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setEmailSenderList, response.data);
                return response;
            })
            .catch((err) => {
                commit(storeMutation.setEmailSenderList);
                console.log(err);
                throw err;
            });
    }),
    // [storeAction.getEmailRecipient]: wrapAction(storeAction.getEmailRecipient, ({ state, commit }, requestBody) => {
    //     return axios({
    //         url: `${state.baseURL}profiles/api/champs/get/email-recipient-details/${requestBody.communityId}/${requestBody.recipientType}`,
    //         headers: getBasicHeaders(),
    //         method: 'GET',
    //     })
    //         .then((response) => {
    //             commit(storeMutation.setEmailRecipient, response.data);
    //             return response;
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //             throw err;
    //         });
    // }),
    [storeAction.getEmailRecipientList]: wrapAction(storeAction.getEmailRecipientList, ({ state, commit }, requestBody) => {
        //preparing cancellable axios request
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getEmailRecipientList,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, {
            root: true,
        });

        return axios({
            url: `${state.baseURL}profiles/api/champs/get-email-recipient-list`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: requestBody,
        })
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getEmailRecipientList, { root: true });
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getEmailRecipient]: wrapAction(storeAction.getEmailRecipient, ({ state, commit }, requestBody) => {
        return axios({
            url: requestBody.memberType
                ? `${state.baseURL}profiles/api/champs/get/email-recipient-details/${requestBody.communityId}/${requestBody.recipientType}?memberType=${requestBody.memberType}`
                : `${state.baseURL}profiles/api/champs/get/email-recipient-details/${requestBody.communityId}/${requestBody.recipientType}?eventId=${requestBody.eventId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setEmailRecipient, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.saveEmailContent]: ({ state, commit }, content) => {
        return axios({
            url: `${state.baseURL}profiles/api/champs/save-email-content`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: content,
        })
            .then((response) => {
                commit(storeMutation.setEmailContent, response.data);
                return response;
            })
            .catch((err) => {
                throw err;
            });
    },
    [storeAction.createNewEmail]: ({ state }, content) => {
        return axios({
            url: `${state.baseURL}profiles/api/champs/create-new-email`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: content,
        })
            .then((response) => {
                return response.data;
            })
            .catch((err) => {
                throw err;
            });
    },
    [storeAction.createSignature]: ({ state }, content) => {
        return axios({
            url: `${state.baseURL}profiles/api/champs/create-new-signature/${content.communityId}`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: content.data,
        })
            .then((response) => {
                return response.data;
            })
            .catch((err) => {
                throw err;
            });
    },
    [storeAction.getSignatureList]: ({ state }, communityId) => {
        return axios({
            url: `${state.baseURL}profiles/api/champs/get-signature-list/${communityId}`,
            headers: getBasicHeaders(),
            method: 'Get',
        })
            .then((response) => {
                return response.data;
            })
            .catch((err) => {
                throw err;
            });
    },

    [storeAction.champsUploadAttachments]: ({ state }, attachments) => {
        return axios({
            url: `${state.baseURL}profiles/api/champs/upload-attachments/${attachments.communityId}/${attachments.emailId}`,
            headers: getBasicHeaders(),
            data: attachments.formData,
            'Content-Type': 'multipart/form-data',
            method: 'POST',
        })
            .then((response) => {
                return response.data;
            })
            .catch((err) => {
                throw err;
            });
    },
    [storeAction.updateSignature]: ({ state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/champs/update-signature/${requestBody.communityId}`,
            headers: getBasicHeaders(),
            data: requestBody.data,
            method: 'POST',
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                throw err;
            });
    },
    [storeAction.deleteSignature]: ({ state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/champs/delete-signature/${requestBody.communityId}/${requestBody.signatureId}`,
            headers: getBasicHeaders(),
            method: 'DELETE',
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                throw err;
            });
    },
    [storeAction.emailPreview]: ({ state, commit }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/champs/email-preview/${requestBody.communityId}/${requestBody.emailId}`,
            headers: getBasicHeaders(),
            method: 'Get',
        })
            .then((response) => {
                commit(storeMutation.setPreviewEmailContent, response.data);
                return response.data;
            })
            .catch((err) => {
                throw err;
            });
    },
    [storeAction.getEmails]: wrapAction(storeAction.getEmails, ({ state, commit }, requestBody) => {
        //preparing cancellable axios request
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getEmails,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, {
            root: true,
        });

        return axios({
            url: requestBody.isdraft
                ? `${state.baseURL}profiles/api/champs/get-emails/${requestBody.communityId}?isDraft=${true}`
                : `${state.baseURL}profiles/api/champs/get-emails/${requestBody.communityId}`,
            headers: getBasicHeaders(),
            method: 'GET',
            cancelToken: requestSource.token,
        })
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getEmails, { root: true });
                commit(storeMutation.setAllEmailInformation, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.deleteEmail]: ({ state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/champs/delete-emails`,
            headers: getBasicHeaders(),
            method: 'DELETE',
            data: requestBody,
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.sendEmail]: ({ state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/champs/send-email`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: requestBody,
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getEmailContents]: ({ state, commit }, postBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/champs/get-email-contents/${postBody.communityId}/${postBody.emailid}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setEmailContent, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getTimeZones]: wrapAction(storeAction.getTimeZones, async ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}profiles/api/champs/get-time-zones`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setTimeZonesForEmail, response.data);
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.scheduleEmail]: wrapAction(storeAction.scheduleEmail, async ({ state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/champs/schedule-email`,
            headers: getBasicHeaders(),
            method: 'POST',
            data: requestBody,
        })
            .then((response) => {
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getCustomGroupsList]: wrapAction(storeAction.getCustomGroupsList, ({ state }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/champs/get/email-recipient-details/${requestBody.communityId}/${requestBody.recipientType}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
};

const champsEmailStateGetters = {
    [storeGetters.emailRecipients]: state => state.emailRecipients,
    [storeGetters.emailSenderList]: state => state.emailSenderList,
    [storeGetters.emailContent]: state => state.emailContent,
    [storeGetters.allEmailInformation]: state => state.allEmailInformation,
    [storeGetters.previewEmailContent]: state => state.previewEmailContent,
    [storeGetters.timeZonesForEmail]: state => state.timeZonesForEmail,
};

export default {
    namespaced: true,
    state: {
        initialState: champsEmailState(),
        ...champsEmailState(),
    },
    mutations: { ...champsEmailMutations },
    actions: { ...champsEmailStateActions },
    getters: { ...champsEmailStateGetters },
};
